module.exports = __webpack_public_path__ + "img/live-streaming-4.8de9e04b.png";